import { render } from "./Home.vue?vue&type=template&id=0b3b863b"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/Home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b3b863b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b3b863b', __exports__)) {
    api.reload('0b3b863b', __exports__)
  }
  
  module.hot.accept("./Home.vue?vue&type=template&id=0b3b863b", () => {
    api.rerender('0b3b863b', render)
  })

}


export default __exports__